import App from "App";
import Deals from "pages/apps/crm/Deals";
import LeadsAI from "pages/apps/crm/LeadsAI";
import MainLayout from "layouts/MainLayout";
import Error404 from "pages/error/Error404";
import Reports from "pages/apps/crm/Reports";
import AddLead from "pages/apps/crm/AddLead";
import EditLead from "pages/apps/crm/EditLead";
import Crm from "pages/modules/dashboard/Crm";
import SmartCMAReports from "pages/apps/crm/SmartCMAReports";
import SmartCMAReportDetails from "pages/apps/crm/SmartCMAReportDetails";
import Chat from "pages/apps/chat/Chat";
import CommunicationsCenter from "pages/apps/communications/CommunicationsCenter";
import InvestorDeals from "pages/apps/investor-deals/InvestorDeals";
import Emails from "pages/apps/crm/Emails";
import Calendars from "pages/apps/crm/Calendars";
import Analytics from "pages/apps/crm/Analytics";
import LeadDetails from "pages/apps/crm/LeadDetails";
import DealDetails from "pages/apps/crm/DealDetails";
import EmailSetting from "pages/apps/crm/EmailSetting";
import SomethingWrong from "pages/error/SomethingWrong";
import Collaborators from "pages/apps/crm/Collaborators";
import ReportDetails from "pages/apps/crm/ReportDetails";
import ProfileSettings from "pages/apps/crm/ProfileSettings";
import MainLayoutProvider from "providers/MainLayoutProvider";
import SecuritySettings from "pages/apps/crm/SecuritySettings";
import CardSignIn from "pages/pages/authentication/card/SignIn";
import CardSignOut from "pages/pages/authentication/card/SignOut";
import CardSignUp from "pages/pages/authentication/card/SignUp";
import InternalOnboarding from "pages/apps/crm/InternalOnboarding";
import Onboarding from "pages/pages/authentication/card/Onboarding";
import SignUpPaid from "pages/pages/authentication/card/SignUpPaid";
import BrokerSignUp from "pages/pages/authentication/card/BrokerSignUp";
import RequestDemo from "pages/pages/authentication/card/RequestDemo";
import RequestDemoPage from "pages/events/RequestDemoPage";
import ProtectedRoute from "components/protected-route/ProtectedRoute";
import PricePredictionModel from "pages/apps/crm/PricePredictionModel";
import SubscriptionSettings from "pages/apps/crm/SubscriptionSettings";
import A2PSetup from "pages/apps/crm/A2PSetup";
import { Navigate, RouteObject, createBrowserRouter } from "react-router-dom";
import CardResetPassword from "pages/pages/authentication/card/ResetPassword";
import CardForgotPassword from "pages/pages/authentication/card/ForgotPassword";
// KOPS-511 — navy+gold forgot/reset password pages for the AISearchPortal
// domain. Mounted only on the aisearchportal branch; the main Kairos
// branch keeps the legacy card-layout versions.
import ForgotPasswordAIForward from "pages/ForgotPasswordAIForward";
import ResetPasswordAIForward from "pages/ResetPasswordAIForward";
import ConnectNewEmail from "components/modules/crm/email-settings/ConnectNewEmail";
import SmartCMAWorkflow from "components/smart-cma-workflow/SmartCMAWorkflow";
import PricingPage from "pages/portal/PricingPage";
import EventsPage from "pages/events/EventsPage";
import EventDetailPage from "pages/events/EventDetailPage";
import SurveyPage from "pages/events/SurveyPage";
import ContactsPage from "pages/admin/ContactsPage";
import BrokerLandingPage from "pages/broker/BrokerLandingPage";
import AgentClientHub from "pages/agent-portal/AgentClientHub";
import MarketingHub from "pages/agent-portal/MarketingHub";
import PropertyAlertsCenter from "pages/agent-portal/PropertyAlertsCenter";
import EventsAdminPage from "pages/admin/EventsAdminPage";
import SubscribersPage from "pages/admin/SubscribersPage";
import SupportInboxPage from "pages/admin/SupportInboxPage";
import TeamPage from "pages/admin/TeamPage";
import BrokeragesPage from "pages/admin/BrokeragesPage";
import MarketAnalyticsPage from "pages/admin/MarketAnalyticsPage";
import BuyerPortalReadOnly from "pages/portal/BuyerPortalReadOnly";
import MarketIntelligencePage from "pages/MarketIntelligencePage";
import SettingsLayout from "layouts/SettingsLayout";
import BrokerIntelligenceHub from "components/BrokerIntelligence/BrokerIntelligenceHub";
import BrokerIntelligenceHubV2 from "pages/broker-intelligence/BrokerIntelligenceHub";
import AgentDocumentsHub from "pages/agent-portal/AgentDocumentsHub";
import CountyDealsPage from "pages/agent-portal/CountyDealsPage";
import CompanyProfileHub from "components/BrokerIntelligence/CompanyProfileHub";
import AddDealV2Demo from "components/demo/AddDealV2Demo";
import TestSmartChecklist from "components/TestSmartChecklist";
import BrokerPortal from "pages/broker-portal/BrokerPortalHub";
import TeamLeadHub from "pages/team-lead/TeamLeadHub";
import LenderSponsorHub from "pages/lender/LenderSponsorHub";
import SponsorWelcomePage from "pages/sponsor/SponsorWelcomePage";
import SponsorSignupPage from "pages/sponsor/SponsorSignupPage";
import SponsorLandingPage from "pages/sponsor/SponsorLandingPage";
import SponsorsPage from "pages/admin/SponsorsPage";
import FacebookAdsPage from "pages/admin/FacebookAdsPage"; // KOPS-671: file committed from dev box (was untracked), route restored
import RespaAcknowledgment from "pages/lender/RespaAcknowledgment";
import AgentPortal from "pages/apps/agent-portal/AgentPortal";
import MLSPortal from "pages/apps/mls-portal/MLSPortal";
import SharedProperty from "pages/apps/mls-portal/client/SharedProperty";
import PropertyDetail from "pages/apps/mls-portal/client/PropertyDetail";
import AIOperationsDashboard from "components/AIOperationsDashboard/AIOperationsDashboard";
import CustomerPortalRoutes from "pages/customer-portal/CustomerPortalRoutes";
import SellerValuationWrapper from "pages/public-portal/components/SellerValuationWrapper";
import TransactionDashboard from "components/Transactions/TransactionDashboard";
import HomePage from "pages/public-portal/HomePage";
import HomePageV2 from "pages/public-portal/HomePageV2";
import HomePageV3 from "pages/public-portal/HomePageV3";
import HomePageV4 from "pages/public-portal/HomePageV4";
import SellerCMAChat from "pages/public-portal/SellerCMAChat";
import SearchWithAI from "pages/public-portal/SearchWithAI";
import { PropertyDetail as SEOPropertyDetail } from "pages/PropertyDetail";
import { CityLanding } from "pages/CityLanding";
import { CityLandingV2 } from "pages/CityLandingV2";
import PublicDealReport from "pages/PublicDealReport";
import { NeighborhoodLanding } from "pages/NeighborhoodLanding";
import PropertyChat from "pages/public-portal/components/PropertyChat";
import GilbertLandingPageSimple from "pages/public-portal/GilbertLandingPageSimple";
import HomeValuation from "pages/public-portal/components/HomeValuation";
import AgentMatch from "pages/public-portal/components/AgentMatch";
import PrivacyPolicy from "pages/public-portal/PrivacyPolicy";
import TermsOfService from "pages/public-portal/TermsOfService";
import AIEthicsPolicy from "pages/public-portal/AIEthicsPolicy";
import FairHousingStatement from "pages/public-portal/FairHousingStatement";
import PublicPortalSignIn from "pages/public-portal/SignIn";
import PublicPortalSignUp from "pages/public-portal/SignUp";
import AcceptInvitation from "pages/AcceptInvitationAIForward";
import WhiteLabelHome from "pages/white-label/WhiteLabelHome";
import JoinBrokerage from "pages/public-portal/JoinBrokerage";
import AgentSignupPage from "pages/public-portal/AgentSignupPage";
import PortalLanding from "pages/portal/PortalLanding";
import DirectAccess from "pages/portal/DirectAccess";
import AgentPortalLanding from "pages/agent-portal/AgentPortalLanding";
import AgentSignup from "pages/agent-portal/AgentSignup";
import AgentLogin from "pages/agent-portal/AgentLogin";
import AgentDashboard from "pages/agent-portal/AgentDashboardModern";
import ClientDetailsPage from "pages/apps/ClientDetailsPage";
import PortalPrivacyPolicy from "pages/portal/PrivacyPolicy";
import PortalTermsOfService from "pages/portal/TermsOfService";
import PortalFairHousingStatement from "pages/portal/FairHousingStatement";
import PortalAIEthicsPolicy from "pages/portal/AIEthicsPolicy";
import OfferNowAZHome from "pages/offernowaz/OfferNowAZHome";
import OfferNowAZThankYou from "pages/offernowaz/OfferNowAZThankYou";
import DealDashboard from "components/deals/DealDashboard";
import DealAnalysis from "components/deals/DealAnalysis";
import { 
  isChatRealEstateDomain, 
  isAISearchPortalDomain, 
  isOfferNowAZDomain,
  isWhiteLabelDomain,
  logDomainInfo 
} from "utils/domainDetection";

// Helper function to get chat.realestate routes
const getChatRealEstateRoutes = (): RouteObject[] => {
  console.log('🏠 Loading chat.realestate routes');
  return [
    {
      element: <App />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "prototype",
          element: <HomePageV2 />,
        },
        {
          path: "ai",
          element: <HomePageV3 />,
        },
        {
          path: "v4",
          element: <HomePageV4 />,
        },
        {
          path: "chat",
          element: <PropertyChat />,
        },
        {
          path: "home-value",
          element: <HomeValuation />,
        },
        {
          path: "find-agent",
          element: <AgentMatch />,
        },
        {
          path: "cma-report/:reportId",
          element: <SellerCMAChat />,
        },
        {
          path: "deal-report/:shareId",
          element: <PublicDealReport />,
        },
        {
          path: "join",
          element: <JoinBrokerage />,
        },
        {
          path: "gilbert",
          element: <GilbertLandingPageSimple />,
        },
        {
          path: "search",
          element: <SearchWithAI />,
        },
        {
          path: "search/*",
          element: <SearchWithAI />,
        },
        {
          path: "sign-in",
          element: <PublicPortalSignIn />,
        },
        {
          path: "sign-up",
          element: <PublicPortalSignUp />,
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />,
        },
        {
          path: "terms-of-service",
          element: <TermsOfService />,
        },
        {
          path: "ai-ethics",
          element: <AIEthicsPolicy />,
        },
        {
          path: "fair-housing",
          element: <FairHousingStatement />,
        },
        {
          path: "customer-portal/*",
          element: <CustomerPortalRoutes />,
        },
        {
          path: "property/:mlsNumber",
          element: <SEOPropertyDetail />,
        },
        {
          path: "p/:shortLink",
          element: <SEOPropertyDetail />,
        },
        {
          path: "homes-for-sale/:city",
          element: <CityLandingV2 />,
        },
        {
          path: "homes-for-sale/:city/:neighborhood",
          element: <NeighborhoodLanding />,
        },
        {
          path: "*",
          element: <Error404 />,
        },
      ],
    },
  ];
};

// Define routes based on domain
const getRoutes = (): RouteObject[] => {
  // Log domain detection info for debugging
  logDomainInfo();
  
  // AISearchPortal - special invite-only portal
  if (isAISearchPortalDomain()) {
    console.log('🔐 AISearchPortal detected - loading portal routes');
    return [
      {
        element: <App />,
        children: [
          {
            index: true,
            element: typeof window !== 'undefined' && window.location.hostname.includes('demo.kairosiq.ai')
              ? <Navigate to="/agent-portal/login" replace />
              : <AgentPortalLanding />,
          },
          {
            path: "invite/:token",
            element: <PortalLanding />,
          },
          {
            path: "pricing",
            element: <PricingPage />,
          },
          {
            path: "request-demo",
            element: <RequestDemoPage />,
          },
          {
            path: "book-demo",
            element: <RequestDemoPage />,
          },
          {
            path: "events",
            element: <EventsPage />,
          },
          {
            path: "events/:eventId",
            element: <EventDetailPage />,
          },
          {
            path: "events/:eventId/survey",
            element: <SurveyPage />,
          },
          {
            path: "cma-report/:reportId",
            element: <SellerCMAChat />,
          },
          {
            path: "broker",
            element: <BrokerLandingPage />,
          },
          {
            // Public lead signup via agent link/QR code
            path: "signup/:slug",
            element: <AgentSignupPage />,
          },
          {
            path: "agent-portal/clients",
            element: <ProtectedRoute><AgentClientHub /></ProtectedRoute>,
          },
          {
            // KOPS-584 — Marketing Hub (ListReports killer)
            path: "agent-portal/marketing",
            element: <ProtectedRoute><MarketingHub /></ProtectedRoute>,
          },
          {
            path: "agent-portal/property-alerts",
            element: <ProtectedRoute><PropertyAlertsCenter /></ProtectedRoute>,
          },
          {
            // KOPS-571 — Lender Portal route alias for Pipeline Management
            path: "lender-portal/pipeline",
            element: <ProtectedRoute><AgentClientHub /></ProtectedRoute>,
          },
          {
            path: "lender-portal/clients",
            element: <ProtectedRoute><AgentClientHub /></ProtectedRoute>,
          },
          {
            // KOPS-534 — Maricopa County Deals dashboard
            path: "agent-portal/county-deals",
            element: <ProtectedRoute><CountyDealsPage /></ProtectedRoute>,
          },
          {
            path: "admin/subscribers",
            element: <ProtectedRoute><SubscribersPage /></ProtectedRoute>,
          },
          {
            path: "admin/team",
            element: <ProtectedRoute><TeamPage /></ProtectedRoute>,
          },
          {
            // KOPS-513 — Admin brokerage directory (our customers)
            path: "admin/brokerages",
            element: <ProtectedRoute><BrokeragesPage /></ProtectedRoute>,
          },
          {
            // KOPS-533 — Admin sponsor management
            path: "admin/sponsors",
            element: <ProtectedRoute><SponsorsPage /></ProtectedRoute>,
          },
          {
            // KOPS-513 — MLS market analytics (entire market for sales)
            path: "admin/market-analytics",
            element: <ProtectedRoute><MarketAnalyticsPage /></ProtectedRoute>,
          },
          {
            path: "admin/contacts",
            element: <ProtectedRoute><ContactsPage /></ProtectedRoute>,
          },
          {
            path: "admin/support",
            element: <ProtectedRoute><SupportInboxPage /></ProtectedRoute>,
          },
          {
            path: "admin/events",
            element: <ProtectedRoute><EventsAdminPage /></ProtectedRoute>,
          },
          {
            // KOPS-671 — Facebook Ads Manager (page file recovered from dev box)
            path: "admin/facebook-ads",
            element: <ProtectedRoute><FacebookAdsPage /></ProtectedRoute>,
          },
          {
            // KOPS-465 / KOPS-511 — Broker Intelligence Hub V2 (navy+gold rebuild).
            // Mounted in the AISearchPortal domain branch so dev.aisearchportal.com
            // can load it. Gated client-side by permissions.ts brokerIntelligenceV2 rule.
            //
            // Both `broker-intelligence/*` and `broker-intelligence-v2/*` render
            // the same component — the unsuffixed path is the canonical one
            // from the migration plan, the -v2 suffix was kept for any stale
            // bookmarks. MUST be declared before the `:agentSlug` catch-all
            // below or React Router treats "broker-intelligence" as a slug
            // and falls through to HomePageV3.
            path: "broker-intelligence/*",
            element: <ProtectedRoute><BrokerIntelligenceHubV2 /></ProtectedRoute>,
          },
          {
            path: "broker-intelligence-v2/*",
            element: <ProtectedRoute><BrokerIntelligenceHubV2 /></ProtectedRoute>,
          },
          {
            // KOPS-511 — Broker Portal (transactions, templates, deal management).
            // Commission and billing workflows live here.
            path: "broker-portal/*",
            element: <ProtectedRoute><BrokerPortal /></ProtectedRoute>,
          },
          {
            // KOPS-533 — Team Lead Hub (manage team agents, billing)
            path: "team-lead/*",
            element: <ProtectedRoute><TeamLeadHub /></ProtectedRoute>,
          },
          {
            // KOPS-545 — Sponsor partnership landing page (public)
            path: "partners",
            element: <SponsorLandingPage />,
          },
          {
            // KOPS-545 — Sponsor self-serve signup (public)
            path: "sponsor/signup",
            element: <SponsorSignupPage />,
          },
          {
            // KOPS-533 — Public pages FIRST (before wildcard catches them)
            path: "sponsor/welcome",
            element: <SponsorWelcomePage />,
          },
          {
            path: "sponsor/respa-acknowledge",
            element: <RespaAcknowledgment />,
          },
          {
            path: "lender/respa-acknowledge",
            element: <RespaAcknowledgment />,
          },
          {
            // KOPS-533 — Sponsor Dashboard (protected — must be after specific public routes)
            path: "sponsor/*",
            element: <ProtectedRoute><LenderSponsorHub /></ProtectedRoute>,
          },
          {
            path: "lender/*",
            element: <ProtectedRoute><LenderSponsorHub /></ProtectedRoute>,
          },
          {
            // KOPS-465 — Agent Portal document submission surface (AIAgentPortal).
            // Closes the compliance workflow loop: agents upload here, broker
            // reviews in /broker-intelligence-v2/compliance.
            path: "agent-portal/documents",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            // KOPS-511 — Transactions tab of the Agent Portal Docs Hub.
            // Mounts existing TransactionDashboard + TransactionDetails
            // components inside the navy+gold hub shell.
            path: "agent-portal/transactions",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            path: "agent-portal/transactions/:transactionId/*",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            // KOPS-465 — Investor Deals tab of the Agent Portal Docs Hub.
            // Same component as agent-portal/documents; the hub reads the
            // URL path to pick the active tab so the URL stays in sync
            // with what the user sees + back button works naturally.
            path: "agent-portal/investor-deals",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            path: "agent-portal/investor-deals/:dealId",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            // KOPS-512 — Ask the Broker RAG chat tab
            path: "agent-portal/ask-the-broker",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            // Interoffice Chat — agent-to-agent real-time messaging
            path: "agent-portal/interoffice-chat",
            element: <ProtectedRoute><AgentDocumentsHub /></ProtectedRoute>,
          },
          {
            path: "ai-operations",
            element: <ProtectedRoute><AIOperationsDashboard /></ProtectedRoute>,
          },
          {
            path: "ai-operations/:tab",
            element: <ProtectedRoute><AIOperationsDashboard /></ProtectedRoute>,
          },
          {
            path: "smart-cma-workflow",
            element: <ProtectedRoute><SmartCMAWorkflow /></ProtectedRoute>,
          },
          {
            path: "buyer-portal",
            element: <BuyerPortalReadOnly />,
          },
          {
            // KOPS-465 — Investor Deals tab mounted in Agent Portal Docs
            // Hub navigates to /investor-deals/:id when a deal card is
            // clicked. Must be declared BEFORE the :userId/:leadId
            // catch-all below, otherwise React Router interprets the
            // URL as two-segment direct access and DirectAccess throws
            // "Agent not found" because "investor-deals" isn't a user id.
            path: "investor-deals",
            element: <ProtectedRoute><DealDashboard /></ProtectedRoute>,
          },
          {
            path: "investor-deals/:id",
            element: <ProtectedRoute><DealAnalysis /></ProtectedRoute>,
          },
          {
            // KOPS-465 — invite flow lands here when an agent clicks the
            // email link. Must be declared BEFORE the :userId/:leadId
            // catch-all so React Router matches it first.
            path: "accept-invitation",
            element: <AcceptInvitation />,
          },
          {
            path: "activate/:token",
            element: <AcceptInvitation />,
          },
          {
            path: ":userId/:leadId",
            element: <DirectAccess />,
          },
          // Public lead signup via agent link/QR code
          {
            path: "signup/:slug",
            element: <AgentSignupPage />,
          },
          // Agent management routes
          {
            path: "agent-portal",
            element: <AgentPortalLanding />,
          },
          {
            path: "agent-portal/signup",
            element: <AgentSignup />,
          },
          {
            path: "agent-portal/login",
            element: <AgentLogin />,
          },
          {
            path: "agent-portal/forgot-password",
            element: <ForgotPasswordAIForward />,
          },
          {
            path: "agent-portal/reset-password",
            element: <ResetPasswordAIForward />,
          },
          {
            path: "agent-portal/dashboard",
            element: <ProtectedRoute><AgentDashboard /></ProtectedRoute>,
          },
          {
            path: "agent-portal/dashboard/*",
            element: <ProtectedRoute><AgentDashboard /></ProtectedRoute>,
          },
          {
            path: "agent-portal/client/:leadId",
            element: <ProtectedRoute><ClientDetailsPage /></ProtectedRoute>,
          },
          {
            path: "agent-portal/settings",
            element: <ProtectedRoute><ProfileSettings /></ProtectedRoute>,
          },
          {
            path: "sign-in",
            element: <Navigate to="/agent-portal/login" replace />,
          },
          {
            path: "sign-out",
            element: <CardSignOut />,
          },
          // NOTE: `:agentSlug` / `:agentSlug/*` render HomePageV3 in
          // portal mode. These were briefly removed to stop typos from
          // landing on a personal profile, but DirectAccess.tsx
          // navigate()s to `/${agentSlug}` as the final hop of the
          // buyer-link validation flow, which broke when the route
          // didn't exist. Re-added here and declared BEFORE the `*`
          // fallback so single-segment URLs route to the portal
          // (restoring direct-access links) but multi-segment typos
          // still fall through to the home-page redirect below.
          {
            path: "privacy-policy",
            element: <PortalPrivacyPolicy />,
          },
          {
            path: "terms-of-service",
            element: <PortalTermsOfService />,
          },
          {
            path: "fair-housing",
            element: <PortalFairHousingStatement />,
          },
          {
            path: "ai-ethics",
            element: <PortalAIEthicsPolicy />,
          },
          {
            path: "cookie-policy",
            element: <PortalPrivacyPolicy />,
          },
          {
            path: "data-processing",
            element: <PortalPrivacyPolicy />,
          },
          {
            // /dashboard → redirect to home
            path: "dashboard",
            element: <Navigate to="/" replace />,
          },
          {
            path: "dashboard/*",
            element: <Navigate to="/" replace />,
          },
          {
            // Agent portal links: /:agentId/:leadId → buyer property search portal
            path: ":agentSlug/:leadSlug",
            element: <HomePageV3 />,
          },
          {
            // Agent profile links: /:agentSlug → agent portal landing or property search
            path: ":agentSlug",
            element: <HomePageV3 />,
          },
          {
            // Fallback — any remaining unmatched path under
            // Unknown paths on this domain tree (app.kairosiq.ai / aisearchportal.com)
            // show the branded 404 (with Contact Support) instead of silently
            // redirecting to the portal home. The old redirect masked missing
            // routes — e.g. it bounced valid reset-password links to the portal.
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ];
  }
  
  // White-Label domain - serve same interface with custom branding from database
  if (isWhiteLabelDomain()) {
    return [
      {
        element: <App />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: "prototype",
            element: <HomePageV2 />,
          },
          {
            path: "ai", 
            element: <HomePageV3 />,
          },
          {
            path: "v4",
            element: <HomePageV4 />,
          },
          {
            path: "chat",
            element: <PropertyChat />,
          },
          {
            path: "home-value",
            element: <HomeValuation />,
          },
          {
            path: "find-agent",
            element: <AgentMatch />,
          },
          {
            path: "cma-report/:reportId",
            element: <SellerCMAChat />,
          },
          {
            path: "search",
            element: <SearchWithAI />,
          },
          {
            path: "search/*",
            element: <SearchWithAI />,
          },
          {
            path: "sign-up",
            element: <PublicPortalSignUp />,
          },
          {
            path: "privacy-policy",
            element: <PrivacyPolicy />,
          },
          {
            path: "terms-of-service",
            element: <TermsOfService />,
          },
          {
            path: "ai-ethics",
            element: <AIEthicsPolicy />,
          },
          {
            path: "fair-housing",
            element: <FairHousingStatement />,
          },
          {
            path: "customer-portal/*",
            element: <CustomerPortalRoutes />,
          },
          {
            path: "property/:mlsNumber",
            element: <SEOPropertyDetail />,
          },
          {
            path: "p/:shortLink",
            element: <SEOPropertyDetail />,
          },
          {
            path: "homes-for-sale/:city",
            element: <CityLandingV2 />,
          },
          {
            path: "homes-for-sale/:city/:neighborhood",
            element: <NeighborhoodLanding />,
          },
          {
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ];
  }
  
  // Chat.RealEstate domain - serve the same content as dev.kairosiq.ai/chat-realestate
  if (isChatRealEstateDomain()) {
    console.log('🏠 chat.realestate domain detected - loading public portal routes');
    return getChatRealEstateRoutes();
  }

  // OfferNowAZ domain - distressed property acquisition site
  if (isOfferNowAZDomain()) {
    console.log('🏠 OfferNowAZ domain detected - loading OfferNowAZ routes');
    return [
      {
        element: <App />,
        children: [
          {
            index: true,
            element: <OfferNowAZHome />,
          },
          {
            path: "thank-you",
            element: <OfferNowAZThankYou />,
          },
          {
            path: "privacy",
            element: <PrivacyPolicy />,
          },
          {
            path: "terms",
            element: <TermsOfService />,
          },
          {
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ];
  }

  // Default app.kairosiq.ai and app.agentkairos.com routes
  console.log('⚠️ No specific domain matched - loading default KairosIQ routes (NO GILBERT PAGE)');
  return [
  {
    element: <App />,
    children: [
      {
        index: true,
        element: isChatRealEstateDomain() ? <HomePageV3 /> : <Navigate to="/sign-in" replace />,
      },
      // Public search routes for chat.realestate domains
      {
        path: "search",
        element: isChatRealEstateDomain() ? <SearchWithAI /> : <Navigate to="/sign-in" replace />,
      },
      {
        path: "search/*",
        element: isChatRealEstateDomain() ? <SearchWithAI /> : <Navigate to="/sign-in" replace />,
      },
      {
        path: "/",
        element: (
          <MainLayoutProvider>
            <MainLayout />
          </MainLayoutProvider>
        ),
        children: [
          {
            path: "/",
            children: [
              {
                path: "dashboard",
                element: (
                  <ProtectedRoute>
                    <Crm />
                  </ProtectedRoute>
                ),
              },
              // Redirects for backward compatibility
              {
                path: "dashboard/clients",
                element: <Navigate to="/transactions/clients" replace />,
              },
              {
                path: "dashboard/transactions",
                element: <Navigate to="/transactions/active-deals" replace />,
              },
              {
                path: "analytics",
                element: (
                  <ProtectedRoute>
                    <Analytics />
                  </ProtectedRoute>
                ),
              },
              {
                path: "deals",
                element: (
                  <ProtectedRoute>
                    <Deals />
                  </ProtectedRoute>
                ),
              },
              {
                path: "deals/:id",
                element: (
                  <ProtectedRoute>
                    <DealDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "investor-deals",
                element: (
                  <ProtectedRoute>
                    <DealDashboard />
                  </ProtectedRoute>
                ),
              },
              {
                path: "investor-deals/:id",
                element: (
                  <ProtectedRoute>
                    <DealAnalysis />
                  </ProtectedRoute>
                ),
              },
              {
                path: "demo/deal-modal-v2",
                element: (
                  <ProtectedRoute>
                    <AddDealV2Demo />
                  </ProtectedRoute>
                ),
              },
              {
                path: "report-details",
                element: (
                  <ProtectedRoute>
                    <ReportDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "leads",
                element: (
                  <ProtectedRoute>
                    <LeadsAI />
                  </ProtectedRoute>
                ),
              },
              {
                path: "edit-lead/:id",
                element: (
                  <ProtectedRoute>
                    <EditLead />
                  </ProtectedRoute>
                ),
              },
              {
                path: "leads/:id",
                element: (
                  <ProtectedRoute>
                    <LeadDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "reports",
                element: (
                  <ProtectedRoute>
                    <Reports />
                  </ProtectedRoute>
                ),
              },
              {
                path: "add-lead",
                element: (
                  <ProtectedRoute>
                    <AddLead />
                  </ProtectedRoute>
                ),
              },
              // {
              //   path: "add-deal",
              //   element: (
              //     <ProtectedRoute>
              //       <AddDeal />
              //     </ProtectedRoute>
              //   ),
              // },
              {
                path: "collaborators",
                element: (
                  <ProtectedRoute>
                    <Collaborators />
                  </ProtectedRoute>
                ),
              },
              // The Settings menu is defined in sitemap.tsx
              // We don't need to define it here in Routes.tsx
              // This prevents TypeScript errors since RouteObject doesn't support custom properties
              // like 'name', 'icon', etc.
              {
                path: "price-prediction-model",
                element: (
                  <ProtectedRoute>
                    <PricePredictionModel />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-reports",
                element: (
                  <ProtectedRoute>
                    <SmartCMAReports />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-report/:reportId",
                element: (
                  <ProtectedRoute>
                    <SmartCMAReportDetails />
                  </ProtectedRoute>
                ),
              },
              {
                path: "smart-cma-workflow",
                element: (
                  <ProtectedRoute>
                    <SmartCMAWorkflow />
                  </ProtectedRoute>
                ),
              },
              {
                path: "test-smart-checklist",
                element: (
                  <ProtectedRoute>
                    <TestSmartChecklist />
                  </ProtectedRoute>
                ),
              },
              {
                path: "market-intelligence",
                element: (
                  <ProtectedRoute>
                    <MarketIntelligencePage />
                  </ProtectedRoute>
                ),
              },
              {
                path: "broker-intelligence/*",
                element: (
                  <ProtectedRoute>
                    <BrokerIntelligenceHub />
                  </ProtectedRoute>
                ),
              },
              {
                // KOPS-465 / KOPS-511 — navy+gold rebuild preview.
                // Lives alongside the old hub; will swap at end of migration.
                path: "broker-intelligence-v2/*",
                element: (
                  <ProtectedRoute>
                    <BrokerIntelligenceHubV2 />
                  </ProtectedRoute>
                ),
              },
              {
                // KOPS-465 — Agent Portal document submission surface (AIAgentPortal).
                path: "agent-portal/documents",
                element: (
                  <ProtectedRoute>
                    <AgentDocumentsHub />
                  </ProtectedRoute>
                ),
              },
              {
                path: "company-profile",
                element: (
                  <ProtectedRoute>
                    <CompanyProfileHub />
                  </ProtectedRoute>
                ),
              },
              // broker-portal routes removed — now mounted at top level
              // (line ~335) with wildcard broker-portal/* so all sub-tabs
              // (document-review, templates, etc.) resolve correctly.
              {
                path: "agent-portal/*",
                element: (
                  <ProtectedRoute>
                    <AgentPortal />
                  </ProtectedRoute>
                ),
              },
              {
                path: "transactions",
                element: (
                  <ProtectedRoute>
                    <TransactionDashboard />
                  </ProtectedRoute>
                ),
              },
              {
                path: "transactions/:tab",
                element: (
                  <ProtectedRoute>
                    <TransactionDashboard />
                  </ProtectedRoute>
                ),
              },
              {
                path: "mls-portal",
                element: (
                  <ProtectedRoute>
                    <MLSPortal />
                  </ProtectedRoute>
                ),
              },
              {
                path: "mls-portal/property/:mlsNumber",
                element: (
                  <ProtectedRoute>
                    <PropertyDetail />
                  </ProtectedRoute>
                ),
              },
              {
                path: "mls-portal/shared/:shareToken",
                element: <SharedProperty />,
              },
              {
                path: "ai-operations",
                element: (
                  <ProtectedRoute>
                    <AIOperationsDashboard />
                  </ProtectedRoute>
                ),
              },
              {
                path: "ai-operations/:tab",
                element: (
                  <ProtectedRoute>
                    <AIOperationsDashboard />
                  </ProtectedRoute>
                ),
              },
              {
                path: "communications",
                element: (
                  <ProtectedRoute>
                    <CommunicationsCenter />
                  </ProtectedRoute>
                ),
              },
              {
                path: "investor-deals",
                element: (
                  <ProtectedRoute>
                    <InvestorDeals />
                  </ProtectedRoute>
                ),
              },
              {
                path: "chat",
                element: (
                  <ProtectedRoute>
                    <Chat />
                  </ProtectedRoute>
                ),
                children: [
                  {
                    index: true,
                    element: <Chat />,
                  },
                ],
              },
              {
                path: "/",
                children: [
                  {
                    path: "/email-settings/new-email",
                    element: <ProtectedRoute><ConnectNewEmail /></ProtectedRoute>,
                  },
                  {
                    path: "/emails",
                    element: <ProtectedRoute><Emails /></ProtectedRoute>,
                  },
                  {
                    path: "/calendars",
                    element: <ProtectedRoute><Calendars /></ProtectedRoute>,
                  },
                ],
              },
              {
                path: "settings",
                element: (
                  <ProtectedRoute>
                    <SettingsLayout />
                  </ProtectedRoute>
                ),
                children: [
                  {
                    index: true,
                    element: <Navigate to="/settings/subscription-settings" replace />,
                  },
                  {
                    path: "profile-settings",
                    element: <ProfileSettings />,
                  },
                  {
                    path: "security-settings",
                    element: <SecuritySettings />,
                  },
                  {
                    path: "subscription-settings",
                    element: <SubscriptionSettings />,
                  },
                  {
                    path: "email-settings",
                    element: <EmailSetting />,
                  },
                  {
                    path: "onboarding",
                    element: <InternalOnboarding />,
                  },
                ],
              },
              {
                path: "a2p-setup",
                element: (
                  <ProtectedRoute>
                    <A2PSetup />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "/",
        children: [
          {
            path: "sign-up-paid",
            element: <SignUpPaid />,
          },
          {
            path: "broker-signup",
            element: <BrokerSignUp />,
          },
          {
            path: "request-demo",
            element: <RequestDemo />,
          },
          {
            path: "onboarding",
            element: <Onboarding />,
          },
          {
            path: "sign-in",
            element: <CardSignIn />,
          },
          {
            path: "sign-up",
            element: <CardSignUp />,
          },
          {
            path: "sign-out",
            element: <CardSignOut />,
          },
          {
            path: "forgot-password",
            element: <CardForgotPassword />,
          },
          {
            path: "reset-password",
            element: <CardResetPassword />,
          },
          {
            path: "accept-invitation",
            element: <AcceptInvitation />,
          },
          {
            path: "activate/:token",
            element: <AcceptInvitation />,
          },
          {
            path: "seller-valuation",
            element: <SellerValuationWrapper />,
          },
          {
            path: "cancel",
            element: <SomethingWrong />,
          },
          {
            path: "customer-portal/*",
            element: <CustomerPortalRoutes />,
          },
          {
            path: "chat-realestate",
            element: <HomePage />,
          },
          {
            path: "chat-realestate/prototype",
            element: <HomePageV2 />,
          },
          {
            path: "chat-realestate/ai",
            element: <HomePageV3 />,
          },
          {
            path: "chat-realestate/v4",
            element: <HomePageV4 />,
          },
          {
            path: "chat-realestate/chat",
            element: <PropertyChat />,
          },
          {
            path: "chat-realestate/home-value",
            element: <HomeValuation />,
          },
          {
            path: "chat-realestate/find-agent",
            element: <AgentMatch />,
          },
          {
            path: "*",
            element: <Error404 />,
          },
        ],
      },
    ],
  },
  ];
};

// Get routes based on current domain
const routes = getRoutes();

export const router = createBrowserRouter(routes);

export default routes;
// Trigger recompile
